export default __webpack_public_path__ + "static/media/012-rainbow.645eb594.svg";